import React from "react";
import Sidebar from "../../common/components/Sidebar/sidebar";
import FormHeader from "../../common/components/FormHeader/FormHeader";
import Strings from "../../common/res/String";
import AddUserForm from "../../common/components/addUserFormComponent/AddUserForm";

const AddUser = () => {
  return (
    <>
      <section className="agent_management_main_section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-3 p-0 m-0">
              <Sidebar />
            </div>
            <div className="col-12 col-lg-8 p-0 m-0">
              <div className="addUserMainContainer my-4">
                <FormHeader header={Strings.adduser} />
                <div className="add-user-form-block">
                  <AddUserForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AddUser;
